<template>
  <div class="ticket">
    <ul class="ticket-header">
      <li class="ticket-th">票品名称</li>
      <li class="ticket-th">类型</li>
      <li class="ticket-th">票价(元)</li>
      <li class="ticket-th">票品库存</li>
      <li class="ticket-th">状态</li>
      <li class="ticket-th">操作</li>
    </ul>
    <template v-if="isEditTickes">
      <template v-for="(item, index) of ticketList2">
        <TicketItem :key="index" :rowData="item" :index="index" :ticketTypeList="ticketTypeList" :ref="`ticketItem${index}`" @changeIsRealName="changeIsRealName" @deleteItem="deleteItem" @sortItem="sortItem" />
      </template>
    </template>
    <template v-else>
      <template v-for="(item, index) of ticketList">
        <TicketItem :key="index" :rowData="item" :index="index" :ticketTypeList="ticketTypeList" :ref="`ticketItem${index}`" @changeIsRealName="changeIsRealName" @deleteItem="deleteItem" @sortItem="sortItem" />
      </template>
    </template>
    <div class="add-ticket">
      <el-button type="primary" @click="addTicket">添加票务</el-button>
    </div>
  </div>
</template>

<script>
import DictService from '@/services/system/dict';
import TicketItem from './TicketItem';
import { fileObjectField } from '@/utils';
import _ from 'lodash'
import { mapActions } from 'vuex';
export default {
  props: {
    ticketPropsList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      ticketList: [{
        name: '',
        typeId: '',
        price: '',
        count: '',
        status: 0,
        description: '',
        isLimit: false,
        limitCount: 1,
      }],
      ticketList2: _.cloneDeep(this.ticketPropsList),
      ticketTypeList: [],
    }
  },
  methods: {
    // 获取类型
    async initDictTicketTypeList () {
      const { code, result } = await DictService.dictByTypeApi({ category: 'ticket_type' });
      if (Object.is(code, 0)) {
        this.ticketTypeList = result;
      } else {
        console.log('获取票务类型失败');
      }
    },
    addTicket () {
      let data = {
        name: '',
        typeId: '',
        price: '',
        count: '',
        status: 0,
        description: '',
        isLimit: null,
        limitCount: 1,
      }
      if (this.isEditTickes) {
        if (this.ticketList2.length > 50) {
          this.$message.error('票品最多50个');
          return false;
        }
        this.ticketList2.push(data);
      } else {
        if (this.ticketList.length > 50) {
          this.$message.error('票品最多50个');
          return false;
        }
        this.ticketList.push(data);
      }
      console.log(this.ticketList)
    },
    // 删除票务
    deleteItem (index) {
      if (this.isEditTickes) {
        this.ticketList2.splice(index, 1);
        this.setIdCardOpen(this.ticketList2.some( v => v.isRealName == 1))
      } else {
        this.ticketList.splice(index, 1);
        this.setIdCardOpen(this.ticketList.some( v => v.isRealName == 1))
      }
    },
    // 排序
    sortItem ({ type, index }) {
      if (this.isEditTickes) {
        const targetRow = this.ticketList2.splice(index, 1)[0];
        const _index = type == 'up' ? index - 1 : index + 1;
        this.ticketList2.splice(_index, 0, targetRow);
      } else {
        const targetRow = this.ticketList.splice(index, 1)[0];
        const _index = type == 'up' ? index - 1 : index + 1;
        this.ticketList.splice(_index, 0, targetRow);
      }
    },
    // 获取全部票务数据
    async getAllTicketData () {
      const ticketList = [];
      const isValidList = [];

      if (this.isEditTickes) {
        for (const index of this.ticketList2.keys()) {
          const { data, isValid } = await this.$refs[`ticketItem${index}`][0].getFormData();
          ticketList.push(fileObjectField({ ...data, sort: index }));
          isValidList.push(isValid);
        }
      } else {
        for (const index of this.ticketList.keys()) {
          const { data, isValid } = await this.$refs[`ticketItem${index}`][0].getFormData();
          ticketList.push(fileObjectField({ ...data, sort: index }));
          isValidList.push(isValid);
        }
      }
      const isValid = isValidList.every(item => item);
      return { ticketList, isValid };
    },
    changeIsRealName() {
      let data = this.isEditTickes ? this.ticketList2 : this.ticketList;
      this.setIdCardOpen(data.some( v => v.isRealName == 1))
    },
    ...mapActions(['setIdCardOpen'])
  },
  mounted () {
    this.initDictTicketTypeList();
  },
  computed: {
    isEditTickes () {
      return this.ticketPropsList.length
    },
  },
  components: {
    TicketItem,
  }
}
</script>

<style lang="scss" scoped>
.ticket {
  border: 1px solid #ddd;
  padding: 10px;
  width: 170%;
  height: auto;
  margin: 20px 0;
  .ticket-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #f1f2f1;
    .ticket-th {
      flex: 1;
      font-weight: 500;
      color: #333;
      list-style: none;
      text-align: center;
      &:last-child {
        flex: 1.5;
      }
    }
  }
  .add-ticket {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>